<template>
  <div class="mss-admin mss-admin__manage-members px-4">

    <b-card no-body class="rounded-0 shadow-none phairify-cc-box pb-4">
      <b-card-header class="phairify-cc-box-header rounded-0 px-4">
        <b-row align-v="center">
          <b-col class="d-flex align-items-center">
            <div class="d-inline-flex">
              <h2 class="phairify-cc-box-title mb-0">
                <strong>Membership</strong>
              </h2>
            </div>
          </b-col>
          <b-col cols="6" lg="4">
            <b-row align-h="end">
              <b-col cols="12" sm="6" xl="4" class="mt-2 mt-sm-0">
                <b-button
                  variant="white"
                  class="phairify-primary-button w-100"
                  @click="back"
                >Back</b-button
                >
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card-header>

      <div class="px-4">
        <Statistics/>
      </div>

      <hr />

      <div v-if="societyId" class="px-4">
        <members-list :society-id="societyId"/>
      </div>

    </b-card>
  </div>
</template>

<script>
import Statistics from '@/components/society/Statistics';
import SocietyDataProvider from '@/mixins/SocietyDataProvider';
import MembersList from '@/components/society/MembersList';

export default {
  name: 'Main',
  mixins: [SocietyDataProvider],
  components: {
    MembersList,
    Statistics,
  },
  computed: {
    societyId: function () {
      return this.$store.getters.society && this.$store.getters.society.id ? this.$store.getters.society.id : '';
    },
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped></style>
